import { Sparkles, MapPin, Leaf, Users } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = [Sparkles, MapPin, Leaf, Users];

export default function Highlights() {
  const { t } = useLanguage();
  const h = t.highlights;

  return (
    <section
      className="relative border-y border-[#E5DACC] bg-[#FAF7F2] py-16 md:py-24"
      data-testid="highlights-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <h2
          className="mb-12 max-w-2xl text-3xl leading-tight tracking-tight md:text-4xl"
          style={{ fontFamily: "Fraunces, serif" }}
          data-testid="highlights-title"
        >
          {h.title}
        </h2>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#E5DACC] bg-[#E5DACC] sm:grid-cols-2 lg:grid-cols-4">
          {h.items.map((item, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <div
                key={item.title}
                className="group relative flex flex-col gap-3 bg-white p-7 transition-colors hover:bg-[#FFF7F2]"
                data-testid={`highlight-card-${i}`}
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#FF5533]/10 text-[#FF5533] transition-transform group-hover:-rotate-6 group-hover:scale-110">
                  <Icon size={20} strokeWidth={1.75} />
                </div>
                <h3
                  className="text-xl tracking-tight text-[#0A0A0A]"
                  style={{ fontFamily: "Fraunces, serif" }}
                >
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-[#4A4A4A]">
                  {item.body}
                </p>
                <span className="mt-2 text-[10px] font-semibold uppercase tracking-[0.24em] text-[#FF5533]">
                  0{i + 1}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
